import { Member, MemberModel } from "./Member.ts";
import { Speaker, SpeakerModel } from "./Speaker.ts";
import { Guest, GuestModel } from "./Guest.ts";
import { VISIBLE_STATE } from "./StateConstants.ts";


export interface EventModel {
  objectId?: string
  createdAt?: Date
  updatedAt?: Date
  title?: string
  venue?: string
  street?: string
  city?: string
  postalCode?: string
  about?: string
  capacity?: string
  image?: string
  isNew?: boolean
  hidden?: boolean
  location?: any
  startDate?: Date
  endDate?: Date
  members: MemberModel[]
  newEventsOrder?: number
  isQVault?: boolean
  pdfAttachment?: any
  speakers: SpeakerModel[]
  hiddenState: string
  eventCategories: string[]
  interestedMembers: MemberModel[]
  guests: GuestModel[]
  registrationStatus?: string
  registrationStartDate?: Date
}


export class Event implements EventModel {
  objectId?: string
  createdAt?: Date
  updatedAt?: Date
  title?: string
  venue?: string
  street?: string
  city?: string
  postalCode?: string
  about?: string
  capacity?: string
  image?: string
  isNew?: boolean
  hidden?: boolean
  location?: any
  startDate?: Date
  endDate?: Date
  members: MemberModel[]
  newEventsOrder?: number
  isQVault?: boolean
  pdfAttachment?: any
  speakers: SpeakerModel[]
  hiddenState: string
  eventCategories: string[]
  interestedMembers: MemberModel[]
  guests: GuestModel[]
  registrationStatus?: string
  registrationStartDate?: Date

  constructor(
    objectId = undefined,
    createdAt = undefined,
    updatedAt = undefined,
    title = undefined,
    venue = undefined,
    street = undefined,
    city = undefined,
    postalCode = undefined,
    about = undefined,
    capacity = undefined,
    image = undefined,
    isNew = true,
    hidden = true,
    location = {},
    startDate = undefined,
    endDate = undefined,
    members = [],
    newEventsOrder = undefined,
    isQVault = false,
    pdfAttachment = null,
    speakers = [],
    hiddenState = "",
    eventCategories = [],
    interestedMembers = [],
    guests = [],
    registrationStatus = undefined,
    registrationStartDate = undefined
  ) {
    this.objectId = objectId
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.title = title
    this.venue = venue
    this.street = street
    this.city = city
    this.postalCode = postalCode
    this.about = about
    this.capacity = capacity
    this.image = image
    this.isNew = isNew
    this.hidden = hidden
    this.location = location
    this.startDate = startDate
    this.endDate = endDate
    this.members = members
    this.newEventsOrder = newEventsOrder
    this.isQVault = isQVault
    this.pdfAttachment = pdfAttachment
    this.speakers = speakers
    this.hiddenState = hiddenState
    this.eventCategories = eventCategories
    this.interestedMembers = interestedMembers
    this.guests = guests
    this.registrationStatus = registrationStatus
    this.registrationStartDate = registrationStartDate
  }

  static convertFromParseObject(parseObject: any): EventModel {
    const membersParse = parseObject?.get("members")
    const members = membersParse
      ? membersParse.map((member: any) => Member.convertFromParseObject(member))
      : []

    const pdfUrl = parseObject?.get("pdfAttachment")
    const pdfAttachment = pdfUrl === undefined ? null : pdfUrl.url()

    const speakersParse = parseObject?.get("speakers")
    const speakers = speakersParse
      ? speakersParse.map((speaker: any) => Speaker.convertFromParseObject(speaker))
      : []

    const eventCategoriesParse = parseObject?.get("eventCategories")
    const eventCategories = eventCategoriesParse ? eventCategoriesParse : []

    const interestedMembersParse = parseObject?.get("interestedMembers")
    const interestedMembers = interestedMembersParse
      ? interestedMembersParse.map((member: any) => Member.convertFromParseObject(member))
      : []

    const guestsParse = parseObject?.get("guests")
    const guests = guestsParse
      ? guestsParse.map((guest: any) => Guest.convertFromParseObject(guest))
      : []
    const hiddenState = parseObject?.get("hidden") ? VISIBLE_STATE.PRIVATE : VISIBLE_STATE.PUBLIC

    return new Event(
      parseObject?.id,
      parseObject?.updatedAt,
      parseObject?.createdAt,
      parseObject?.get("title"),
      parseObject?.get("venue"),
      parseObject?.get("street"),
      parseObject?.get("city"),
      parseObject?.get("postalCode"),
      parseObject?.get("about"),
      parseObject?.get("capacity"),
      parseObject?.get("image")?.url(),
      parseObject?.get("isNew"),
      parseObject?.get("hidden"),
      parseObject?.get("location"),
      parseObject?.get("startDate"),
      parseObject?.get("endDate"),
      members,
      parseObject?.get("newEventsOrder"),
      parseObject?.get("isQVault") ?? false,
      pdfAttachment,
      speakers,
      hiddenState,
      eventCategories,
      interestedMembers,
      guests,
      parseObject?.get("registrationStatus"),
      parseObject?.get("registrationStartDate")
    )
  }

  convertLocationToMapObject(): { lat: any, lng: any } {
    return {
      lat: this.location.latitude,
      lng: this.location.longitude,
    }
  }
}
